import { render, staticRenderFns } from "./addFault.vue?vue&type=template&id=ab3c68fa&"
import script from "./addFault.vue?vue&type=script&lang=ts&"
export * from "./addFault.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports